var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63591 0.908119C2.22246 0.321574 2.74749 -0.101629 3.33403 0.484916L7.99988 5.15076L12.6657 0.484916C13.2512 -0.10057 13.7773 0.321573 14.3638 0.908118C14.9504 1.49466 15.3725 2.02075 14.787 2.60624L10.1212 7.27208L14.787 11.9379C15.3725 12.5234 14.9504 13.0495 14.3638 13.636C13.7773 14.2226 13.2512 14.6447 12.6657 14.0592L7.99988 9.3934L3.33403 14.0592C2.74749 14.6458 2.22246 14.2226 1.63592 13.636C1.04937 13.0495 0.626167 12.5245 1.21271 11.9379L5.87856 7.27208L1.21271 2.60624C0.626167 2.01969 1.04937 1.49466 1.63591 0.908119Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.28c993a86535708a648847fd45125985.svg";
export { ForwardRef as ReactComponent };